/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  //baseUrl: 'http://camonher.infinitywebtechnologies.com:9064/api/',
  //imagesUrl: 'http://camonher.infinitywebtechnologies.com:9064/',
  
  baseUrl: 'http://stgcerb.cerebruminfotech.com:9065/api/',
  //imagesUrl: 'http://51.79.40.224:9064/',
  imagesUrl: 'http://stgcerb.cerebruminfotech.com:9065/',
  googleMapKey: 'AIzaSyA7Zj-PTZm4sDG-eoiLPA-XohvgxBe95wU'
};
